const printik = [
    {
        "category": "Unisex",
        "variations": [
            {
                "sku": "PRT-G18500-BLACK/2XL",
                "color": "BLACK",
                "size": "2XL"
            },
            {
                "sku": "PRT-G18500-SPORTGREY/S",
                "color": "SPORTGREY",
                "size": "S"
            },
            {
                "sku": "PRT-G18500-BLACK/XL",
                "color": "BLACK",
                "size": "XL"
            },
            {
                "sku": "PRT-G18500-NAVY/L",
                "color": "NAVY",
                "size": "L"
            },
            {
                "sku": "PRT-G18500-SPORTGREY/XL",
                "color": "SPORTGREY",
                "size": "XL"
            },
            {
                "sku": "PRT-G18500-NAVY/S",
                "color": "NAVY",
                "size": "S"
            },
            {
                "sku": "PRT-G18500-SPORTGREY/L",
                "color": "SPORTGREY",
                "size": "L"
            },
            {
                "sku": "PRT-G18500-ROYAL/S",
                "color": "ROYAL",
                "size": "S"
            },
            {
                "sku": "PRT-G18500-BLACK/S",
                "color": "BLACK",
                "size": "S"
            },
            {
                "sku": "PRT-G18500-BLACK/M",
                "color": "BLACK",
                "size": "M"
            },
            {
                "sku": "PRT-G18500-NAVY/2XL",
                "color": "NAVY",
                "size": "2XL"
            },
            {
                "sku": "PRT-G18500-WHITE/L",
                "color": "WHITE",
                "size": "L"
            },
            {
                "sku": "PRT-G18500-RED/XL",
                "color": "RED",
                "size": "XL"
            },
            {
                "sku": "PRT-G18500-BLACK/L",
                "color": "BLACK",
                "size": "L"
            },
            {
                "sku": "PRT-G18500-WHITE/XL",
                "color": "WHITE",
                "size": "XL"
            },
            {
                "sku": "PRT-G18500-WHITE/2XL",
                "color": "WHITE",
                "size": "2XL"
            },
            {
                "sku": "PRT-G18500-WHITE/M",
                "color": "WHITE",
                "size": "M"
            },
            {
                "sku": "PRT-G18500-WHITE/3XL",
                "color": "WHITE",
                "size": "3XL"
            },
            {
                "sku": "PRT-G18500-WHITE/S",
                "color": "WHITE",
                "size": "S"
            },
            {
                "sku": "PRT-G18500-NAVY/XL",
                "color": "NAVY",
                "size": "XL"
            },
            {
                "sku": "PRT-G18500-SPORTGREY/2XL",
                "color": "SPORTGREY",
                "size": "2XL"
            },
            {
                "sku": "PRT-G18500-RED/3XL",
                "color": "RED",
                "size": "3XL"
            },
            {
                "sku": "PRT-G18500-NAVY/M",
                "color": "NAVY",
                "size": "M"
            },
            {
                "sku": "PRT-G18500-BLACK/3XL",
                "color": "BLACK",
                "size": "3XL"
            },
            {
                "sku": "PRT-G18500-RED/M",
                "color": "RED",
                "size": "M"
            },
            {
                "sku": "PRT-G18500-RED/2XL",
                "color": "RED",
                "size": "2XL"
            },
            {
                "sku": "PRT-G18500-SAND/S",
                "color": "SAND",
                "size": "S"
            },
            {
                "sku": "PRT-G18500-SPORTGREY/3XL",
                "color": "SPORTGREY",
                "size": "3XL"
            },
            {
                "sku": "PRT-G18500-SPORTGREY/M",
                "color": "SPORTGREY",
                "size": "M"
            },
            {
                "sku": "PRT-G18500-ROYAL/XL",
                "color": "ROYAL",
                "size": "XL"
            },
            {
                "sku": "PRT-G18500-ROYAL/2XL",
                "color": "ROYAL",
                "size": "2XL"
            },
            {
                "sku": "PRT-G18500-ROYAL/L",
                "color": "ROYAL",
                "size": "L"
            },
            {
                "sku": "PRT-G18500-RED/L",
                "color": "RED",
                "size": "L"
            },
            {
                "sku": "PRT-G18500-ROYAL/M",
                "color": "ROYAL",
                "size": "M"
            },
            {
                "sku": "PRT-G18500-ROYAL/3XL",
                "color": "ROYAL",
                "size": "3XL"
            },
            {
                "sku": "PRT-G18500-RED/S",
                "color": "RED",
                "size": "S"
            }
        ],
        "brand": null,
        "printer": "US1",
        "name": "Unisex Hoodie | G18500",
        "sku": "Unisex-Gildan-Hoodie",
        "id": "7eb6cd30-3907-40da-8953-aca28495d2c3"
    },
    {
        "category": "Unisex",
        "variations": [
            {
                "sku": "PRT-G18000-BLACK/M",
                "color": "BLACK",
                "size": "M"
            },
            {
                "sku": "PRT-G18000-SPORTGREY/S",
                "color": "SPORTGREY",
                "size": "S"
            },
            {
                "sku": "PRT-G18000-FORESTGREEN/M",
                "color": "FORESTGREEN",
                "size": "M"
            },
            {
                "sku": "PRT-G18000-SPORTGREY/XL",
                "color": "SPORTGREY",
                "size": "XL"
            },
            {
                "sku": "PRT-G18000-SAND/2XL",
                "color": "SAND",
                "size": "2XL"
            },
            {
                "sku": "PRT-G18000-SPORTGREY/L",
                "color": "SPORTGREY",
                "size": "L"
            },
            {
                "sku": "PRT-G18000-NAVY/M",
                "color": "NAVY",
                "size": "M"
            },
            {
                "sku": "PRT-G18000-BLACK/S",
                "color": "BLACK",
                "size": "S"
            },
            {
                "sku": "PRT-G18000-BLACK/L",
                "color": "BLACK",
                "size": "L"
            },
            {
                "sku": "PRT-G18000-WHITE/3XL",
                "color": "WHITE",
                "size": "3XL"
            },
            {
                "sku": "PRT-G18000-FORESTGREEN/XL",
                "color": "FORESTGREEN",
                "size": "XL"
            },
            {
                "sku": "PRT-G18000-WHITE/2XL",
                "color": "WHITE",
                "size": "2XL"
            },
            {
                "sku": "PRT-G18000-BLACK/3XL",
                "color": "BLACK",
                "size": "3XL"
            },
            {
                "sku": "PRT-G18000-SPORTGREY/3XL",
                "color": "SPORTGREY",
                "size": "3XL"
            },
            {
                "sku": "PRT-G18000-SAND/3XL",
                "color": "SAND",
                "size": "3XL"
            },
            {
                "sku": "PRT-G18000-FORESTGREEN/S",
                "color": "FORESTGREEN",
                "size": "S"
            },
            {
                "sku": "PRT-G18000-SAND/L",
                "color": "SAND",
                "size": "L"
            },
            {
                "sku": "PRT-G18000-BLACK/2XL",
                "color": "BLACK",
                "size": "2XL"
            },
            {
                "sku": "PRT-G18000-WHITE/S",
                "color": "WHITE",
                "size": "S"
            },
            {
                "sku": "PRT-G18000-WHITE/M",
                "color": "WHITE",
                "size": "M"
            },
            {
                "sku": "PRT-G18000-NAVY/2XL",
                "color": "NAVY",
                "size": "2XL"
            },
            {
                "sku": "PRT-G18000-FORESTGREEN/3XL",
                "color": "FORESTGREEN",
                "size": "3XL"
            },
            {
                "sku": "PRT-G18000-BLACK/XL",
                "color": "BLACK",
                "size": "XL"
            },
            {
                "sku": "PRT-G18000-SPORTGREY/M",
                "color": "SPORTGREY",
                "size": "M"
            },
            {
                "sku": "PRT-G18000-NAVY/L",
                "color": "NAVY",
                "size": "L"
            },
            {
                "sku": "PRT-G18000-NAVY/3XL",
                "color": "NAVY",
                "size": "3XL"
            },
            {
                "sku": "PRT-G18000-FORESTGREEN/2XL",
                "color": "FORESTGREEN",
                "size": "2XL"
            },
            {
                "sku": "PRT-G18000-SAND/S",
                "color": "SAND",
                "size": "S"
            },
            {
                "sku": "PRT-G18000-NAVY/XL",
                "color": "NAVY",
                "size": "XL"
            },
            {
                "sku": "PRT-G18000-FORESTGREEN/L",
                "color": "FORESTGREEN",
                "size": "L"
            },
            {
                "sku": "PRT-G18000-SAND/M",
                "color": "SAND",
                "size": "M"
            },
            {
                "sku": "PRT-G18000-WHITE/L",
                "color": "WHITE",
                "size": "L"
            },
            {
                "sku": "PRT-G18000-NAVY/S",
                "color": "NAVY",
                "size": "S"
            },
            {
                "sku": "PRT-G18000-SAND/XL",
                "color": "SAND",
                "size": "XL"
            },
            {
                "sku": "PRT-G18000-SPORTGREY/2XL",
                "color": "SPORTGREY",
                "size": "2XL"
            },
            {
                "sku": "PRT-G18000-WHITE/XL",
                "color": "WHITE",
                "size": "XL"
            },
            {
                "sku": "PRT-G18000-DARKHEATHER/S",
                "color": "DARKHEATHER",
                "size": "S"
            },
            {
                "sku": "PRT-G18000-LIGHTPINK/2XL",
                "color": "LIGHTPINK",
                "size": "2XL"
            },
            {
                "sku": "PRT-G18000-LIGHTPINK/3XL",
                "color": "LIGHTPINK",
                "size": "3XL"
            },
            {
                "sku": "PRT-G18000-DARKHEATHER/L",
                "color": "DARKHEATHER",
                "size": "L"
            },
            {
                "sku": "PRT-G18000-MAROON/L",
                "color": "MAROON",
                "size": "L"
            },
            {
                "sku": "PRT-G18000-MAROON/M",
                "color": "MAROON",
                "size": "M"
            },
            {
                "sku": "PRT-G18000-RED/2XL",
                "color": "RED",
                "size": "2XL"
            },
            {
                "sku": "PRT-G18000-MAROON/3XL",
                "color": "MAROON",
                "size": "3XL"
            },
            {
                "sku": "PRT-G18000-MAROON/XL",
                "color": "MAROON",
                "size": "XL"
            },
            {
                "sku": "PRT-G18000-RED/L",
                "color": "RED",
                "size": "L"
            },
            {
                "sku": "PRT-G18000-DARKHEATHER/XL",
                "color": "DARKHEATHER",
                "size": "XL"
            },
            {
                "sku": "PRT-G18000-MAROON/S",
                "color": "MAROON",
                "size": "S"
            },
            {
                "sku": "PRT-G18000-ROYAL/3XL",
                "color": "ROYAL",
                "size": "3XL"
            },
            {
                "sku": "PRT-G18000-RED/3XL",
                "color": "RED",
                "size": "3XL"
            },
            {
                "sku": "PRT-G18000-RED/S",
                "color": "RED",
                "size": "S"
            },
            {
                "sku": "PRT-G18000-ROYAL/L",
                "color": "ROYAL",
                "size": "L"
            },
            {
                "sku": "PRT-G18000-ROYAL/M",
                "color": "ROYAL",
                "size": "M"
            },
            {
                "sku": "PRT-G18000-LIGHTPINK/M",
                "color": "LIGHTPINK",
                "size": "M"
            },
            {
                "sku": "PRT-G18000-LIGHTPINK/XL",
                "color": "LIGHTPINK",
                "size": "XL"
            },
            {
                "sku": "PRT-G18000-MAROON/2XL",
                "color": "MAROON",
                "size": "2XL"
            },
            {
                "sku": "PRT-G18000-RED/M",
                "color": "RED",
                "size": "M"
            },
            {
                "sku": "PRT-G18000-DARKHEATHER/3XL",
                "color": "DARKHEATHER",
                "size": "3XL"
            },
            {
                "sku": "PRT-G18000-ROYAL/XL",
                "color": "ROYAL",
                "size": "XL"
            },
            {
                "sku": "PRT-G18000-ROYAL/2XL",
                "color": "ROYAL",
                "size": "2XL"
            },
            {
                "sku": "PRT-G18000-DARKHEATHER/M",
                "color": "DARKHEATHER",
                "size": "M"
            },
            {
                "sku": "PRT-G18000-DARKHEATHER/2XL",
                "color": "DARKHEATHER",
                "size": "2XL"
            },
            {
                "sku": "PRT-G18000-ROYAL/S",
                "color": "ROYAL",
                "size": "S"
            },
            {
                "sku": "PRT-G18000-RED/XL",
                "color": "RED",
                "size": "XL"
            },
            {
                "sku": "PRT-G18000-LIGHTPINK/L",
                "color": "LIGHTPINK",
                "size": "L"
            },
            {
                "sku": "PRT-G18000-LIGHTPINK/S",
                "color": "LIGHTPINK",
                "size": "S"
            }
        ],
        "brand": null,
        "printer": "US1",
        "name": "Unisex Sweatshirt | G18000",
        "sku": "Unisex-Gildan-Sweatshirt",
        "id": "ce251b1c-e7c0-4491-81ca-350128761d07"
    },
    {
        "category": "Unisex",
        "variations": [
            {
                "sku": "PRT_G5000-NAVY/4XL",
                "color": "NAVY",
                "size": "4XL"
            },
            {
                "sku": "PRT_G5000-WHITE/4XL",
                "color": "WHITE",
                "size": "4XL"
            },
            {
                "sku": "PRT_G5000-WHITE/2XL",
                "color": "WHITE",
                "size": "2XL"
            },
            {
                "sku": "PRT_G5000-SAND/5XL",
                "color": "SAND",
                "size": "5XL"
            },
            {
                "sku": "PRT_G5000-NAVY/XL",
                "color": "NAVY",
                "size": "XL"
            },
            {
                "sku": "PRT_G5000-SAND/4XL",
                "color": "SAND",
                "size": "4XL"
            },
            {
                "sku": "PRT_G5000-WHITE/3XL",
                "color": "WHITE",
                "size": "3XL"
            },
            {
                "sku": "PRT_G5000-SPORTGREY/XL",
                "color": "SPORTGREY",
                "size": "XL"
            },
            {
                "sku": "PRT_G5000-WHITE/XL",
                "color": "WHITE",
                "size": "XL"
            },
            {
                "sku": "PRT_G5000-ROYAL/M",
                "color": "ROYAL",
                "size": "M"
            },
            {
                "sku": "PRT_G5000-SAND/2XL",
                "color": "SAND",
                "size": "2XL"
            },
            {
                "sku": "PRT_G5000-BLACK/3XL",
                "color": "BLACK",
                "size": "3XL"
            },
            {
                "sku": "PRT_G5000-WHITE/5XL",
                "color": "WHITE",
                "size": "5XL"
            },
            {
                "sku": "PRT_G5000-NAVY/3XL",
                "color": "NAVY",
                "size": "3XL"
            },
            {
                "sku": "PRT_G5000-SPORTGREY/S",
                "color": "SPORTGREY",
                "size": "S"
            },
            {
                "sku": "PRT_G5000-SPORTGREY/5XL",
                "color": "SPORTGREY",
                "size": "5XL"
            },
            {
                "sku": "PRT_G5000-NAVY/L",
                "color": "NAVY",
                "size": "L"
            },
            {
                "sku": "PRT_G5000-NAVY/S",
                "color": "NAVY",
                "size": "S"
            },
            {
                "sku": "PRT_G5000-WHITE/L",
                "color": "WHITE",
                "size": "L"
            },
            {
                "sku": "PRT_G5000-BLACK/2XL",
                "color": "BLACK",
                "size": "2XL"
            },
            {
                "sku": "PRT_G5000-WHITE/M",
                "color": "WHITE",
                "size": "M"
            },
            {
                "sku": "PRT_G5000-ROYAL/S",
                "color": "ROYAL",
                "size": "S"
            },
            {
                "sku": "PRT_G5000-SPORTGREY/M",
                "color": "SPORTGREY",
                "size": "M"
            },
            {
                "sku": "PRT_G5000-SPORTGREY/4XL",
                "color": "SPORTGREY",
                "size": "4XL"
            },
            {
                "sku": "PRT_G5000-SPORTGREY/2XL",
                "color": "SPORTGREY",
                "size": "2XL"
            },
            {
                "sku": "PRT_G5000-SPORTGREY/3XL",
                "color": "SPORTGREY",
                "size": "3XL"
            },
            {
                "sku": "PRT_G5000-SAND/S",
                "color": "SAND",
                "size": "S"
            },
            {
                "sku": "PRT_G5000-SAND/XL",
                "color": "SAND",
                "size": "XL"
            },
            {
                "sku": "PRT_G5000-SAND/3XL",
                "color": "SAND",
                "size": "3XL"
            },
            {
                "sku": "PRT_G5000-NAVY/5XL",
                "color": "NAVY",
                "size": "5XL"
            },
            {
                "sku": "PRT_G5000-BLACK/XL",
                "color": "BLACK",
                "size": "XL"
            },
            {
                "sku": "PRT_G5000-BLACK/L",
                "color": "BLACK",
                "size": "L"
            },
            {
                "sku": "PRT_G5000-NAVY/2XL",
                "color": "NAVY",
                "size": "2XL"
            },
            {
                "sku": "PRT_G5000-SAND/L",
                "color": "SAND",
                "size": "L"
            },
            {
                "sku": "PRT_G5000-ROYAL/L",
                "color": "ROYAL",
                "size": "L"
            },
            {
                "sku": "PRT_G5000-SPORTGREY/L",
                "color": "SPORTGREY",
                "size": "L"
            },
            {
                "sku": "PRT_G5000-ROYAL/4XL",
                "color": "ROYAL",
                "size": "4XL"
            },
            {
                "sku": "PRT_G5000-ROYAL/3XL",
                "color": "ROYAL",
                "size": "3XL"
            },
            {
                "sku": "PRT_G5000-SAND/M",
                "color": "SAND",
                "size": "M"
            },
            {
                "sku": "PRT_G5000-ROYAL/2XL",
                "color": "ROYAL",
                "size": "2XL"
            },
            {
                "sku": "PRT_G5000-BLACK/S",
                "color": "BLACK",
                "size": "S"
            },
            {
                "sku": "PRT_G5000-BLACK/4XL",
                "color": "BLACK",
                "size": "4XL"
            },
            {
                "sku": "PRT_G5000-BLACK/M",
                "color": "BLACK",
                "size": "M"
            },
            {
                "sku": "PRT_G5000-BLACK/5XL",
                "color": "BLACK",
                "size": "5XL"
            },
            {
                "sku": "PRT_G5000-NAVY/M",
                "color": "NAVY",
                "size": "M"
            },
            {
                "sku": "PRT_G5000-WHITE/S",
                "color": "WHITE",
                "size": "S"
            },
            {
                "sku": "PRT_G5000-ROYAL/XL",
                "color": "ROYAL",
                "size": "XL"
            },
            {
                "sku": "PRT_G5000-ROYAL/5XL",
                "color": "ROYAL",
                "size": "5XL"
            },
            {
                "sku": "PRT_G5000-RED/3XL",
                "color": "RED",
                "size": "3XL"
            },
            {
                "sku": "PRT_G5000-RED/L",
                "color": "RED",
                "size": "L"
            },
            {
                "sku": "PRT_G5000-RED/4XL",
                "color": "RED",
                "size": "4XL"
            },
            {
                "sku": "PRT_G5000-RED/2XL",
                "color": "RED",
                "size": "2XL"
            },
            {
                "sku": "PRT_G5000-RED/M",
                "color": "RED",
                "size": "M"
            },
            {
                "sku": "PRT_G5000-RED/S",
                "color": "RED",
                "size": "S"
            },
            {
                "sku": "PRT_G5000-RED/XL",
                "color": "RED",
                "size": "XL"
            },
            {
                "sku": "PRT_G5000-RED/5XL",
                "color": "RED",
                "size": "5XL"
            },
            {
                "sku": "PRT_G5000-IRISHGREEN/M",
                "color": "IRISHGREEN",
                "size": "M"
            },
            {
                "sku": "PRT_G5000-PURPLE/2XL",
                "color": "PURPLE",
                "size": "2XL"
            },
            {
                "sku": "PRT_G5000-PURPLE/3XL",
                "color": "PURPLE",
                "size": "3XL"
            },
            {
                "sku": "PRT_G5000-LIGHTPINK/2XL",
                "color": "LIGHTPINK",
                "size": "2XL"
            },
            {
                "sku": "PRT_G5000-LIGHTBLUE/S",
                "color": "LIGHTBLUE",
                "size": "S"
            },
            {
                "sku": "PRT_G5000-LIGHTBLUE/5XL",
                "color": "LIGHTBLUE",
                "size": "5XL"
            },
            {
                "sku": "PRT_G5000-PURPLE/L",
                "color": "PURPLE",
                "size": "L"
            },
            {
                "sku": "PRT_G5000-PURPLE/S",
                "color": "PURPLE",
                "size": "S"
            },
            {
                "sku": "PRT_G5000-LIGHTPINK/3XL",
                "color": "LIGHTPINK",
                "size": "3XL"
            },
            {
                "sku": "PRT_G5000-LIGHTPINK/4XL",
                "color": "LIGHTPINK",
                "size": "4XL"
            },
            {
                "sku": "PRT_G5000-LIGHTPINK/M",
                "color": "LIGHTPINK",
                "size": "M"
            },
            {
                "sku": "PRT_G5000-IRISHGREEN/S",
                "color": "IRISHGREEN",
                "size": "S"
            },
            {
                "sku": "PRT_G5000-PURPLE/M",
                "color": "PURPLE",
                "size": "M"
            },
            {
                "sku": "PRT_G5000-PURPLE/XL",
                "color": "PURPLE",
                "size": "XL"
            },
            {
                "sku": "PRT_G5000-LIGHTPINK/S",
                "color": "LIGHTPINK",
                "size": "S"
            },
            {
                "sku": "PRT_G5000-LIGHTPINK/XL",
                "color": "LIGHTPINK",
                "size": "XL"
            },
            {
                "sku": "PRT_G5000-LIGHTBLUE/4XL",
                "color": "LIGHTBLUE",
                "size": "4XL"
            },
            {
                "sku": "PRT_G5000-LIGHTBLUE/XL",
                "color": "LIGHTBLUE",
                "size": "XL"
            },
            {
                "sku": "PRT_G5000-LIGHTBLUE/L",
                "color": "LIGHTBLUE",
                "size": "L"
            },
            {
                "sku": "PRT_G5000-IRISHGREEN/2XL",
                "color": "IRISHGREEN",
                "size": "2XL"
            },
            {
                "sku": "PRT_G5000-LIGHTBLUE/M",
                "color": "LIGHTBLUE",
                "size": "M"
            },
            {
                "sku": "PRT_G5000-IRISHGREEN/L",
                "color": "IRISHGREEN",
                "size": "L"
            },
            {
                "sku": "PRT_G5000-IRISHGREEN/4XL",
                "color": "IRISHGREEN",
                "size": "4XL"
            },
            {
                "sku": "PRT_G5000-PURPLE/5XL",
                "color": "PURPLE",
                "size": "5XL"
            },
            {
                "sku": "PRT_G5000-LIGHTPINK/5XL",
                "color": "LIGHTPINK",
                "size": "5XL"
            },
            {
                "sku": "PRT_G5000-IRISHGREEN/XL",
                "color": "IRISHGREEN",
                "size": "XL"
            },
            {
                "sku": "PRT_G5000-IRISHGREEN/5XL",
                "color": "IRISHGREEN",
                "size": "5XL"
            },
            {
                "sku": "PRT_G5000-LIGHTBLUE/3XL",
                "color": "LIGHTBLUE",
                "size": "3XL"
            },
            {
                "sku": "PRT_G5000-IRISHGREEN/3XL",
                "color": "IRISHGREEN",
                "size": "3XL"
            },
            {
                "sku": "PRT_G5000-LIGHTPINK/L",
                "color": "LIGHTPINK",
                "size": "L"
            },
            {
                "sku": "PRT_G5000-LIGHTBLUE/2XL",
                "color": "LIGHTBLUE",
                "size": "2XL"
            },
            {
                "sku": "PRT_G5000-FORESTGREEN/4XL",
                "color": "FORESTGREEN",
                "size": "4XL"
            },
            {
                "sku": "PRT_G5000-FORESTGREEN/5XL",
                "color": "FORESTGREEN",
                "size": "5XL"
            },
            {
                "sku": "PRT_G5000-FORESTGREEN/L",
                "color": "FORESTGREEN",
                "size": "L"
            },
            {
                "sku": "PRT_G5000-FORESTGREEN/3XL",
                "color": "FORESTGREEN",
                "size": "3XL"
            },
            {
                "sku": "PRT_G5000-FORESTGREEN/M",
                "color": "FORESTGREEN",
                "size": "M"
            },
            {
                "sku": "PRT_G5000-FORESTGREEN/S",
                "color": "FORESTGREEN",
                "size": "S"
            },
            {
                "sku": "PRT_G5000-FORESTGREEN/XL",
                "color": "FORESTGREEN",
                "size": "XL"
            },
            {
                "sku": "PRT_G5000-FORESTGREEN/2XL",
                "color": "FORESTGREEN",
                "size": "2XL"
            },
            {
                "sku": "PRT_G5000-DARKHEATHER/S",
                "color": "DARKHEATHER",
                "size": "S"
            },
            {
                "sku": "PRT_G5000-MAROON/2XL",
                "color": "MAROON",
                "size": "2XL"
            },
            {
                "sku": "PRT_G5000-MAROON/3XL",
                "color": "MAROON",
                "size": "3XL"
            },
            {
                "sku": "PRT_G5000-ORANGE/XL",
                "color": "ORANGE",
                "size": "XL"
            },
            {
                "sku": "PRT_G5000-MAROON/5XL",
                "color": "MAROON",
                "size": "5XL"
            },
            {
                "sku": "PRT_G5000-DARKHEATHER/M",
                "color": "DARKHEATHER",
                "size": "M"
            },
            {
                "sku": "PRT_G5000-ORANGE/3XL",
                "color": "ORANGE",
                "size": "3XL"
            },
            {
                "sku": "PRT_G5000-DARKHEATHER/2XL",
                "color": "DARKHEATHER",
                "size": "2XL"
            },
            {
                "sku": "PRT_G5000-ORANGE/2XL",
                "color": "ORANGE",
                "size": "2XL"
            },
            {
                "sku": "PRT_G5000-MAROON/4XL",
                "color": "MAROON",
                "size": "4XL"
            },
            {
                "sku": "PRT_G5000-DARKHEATHER/3XL",
                "color": "DARKHEATHER",
                "size": "3XL"
            },
            {
                "sku": "PRT_G5000-MAROON/XL",
                "color": "MAROON",
                "size": "XL"
            },
            {
                "sku": "PRT_G5000-ORANGE/5XL",
                "color": "ORANGE",
                "size": "5XL"
            },
            {
                "sku": "PRT_G5000-MAROON/M",
                "color": "MAROON",
                "size": "M"
            },
            {
                "sku": "PRT_G5000-ORANGE/L",
                "color": "ORANGE",
                "size": "L"
            },
            {
                "sku": "PRT_G5000-MAROON/S",
                "color": "MAROON",
                "size": "S"
            },
            {
                "sku": "PRT_G5000-DARKHEATHER/L",
                "color": "DARKHEATHER",
                "size": "L"
            },
            {
                "sku": "PRT_G5000-ORANGE/4XL",
                "color": "ORANGE",
                "size": "4XL"
            },
            {
                "sku": "PRT_G5000-MAROON/L",
                "color": "MAROON",
                "size": "L"
            },
            {
                "sku": "PRT_G5000-ORANGE/S",
                "color": "ORANGE",
                "size": "S"
            },
            {
                "sku": "PRT_G5000-ORANGE/M",
                "color": "ORANGE",
                "size": "M"
            },
            {
                "sku": "PRT_G5000-DARKHEATHER/XL",
                "color": "DARKHEATHER",
                "size": "XL"
            },
            {
                "sku": "PRT_G5000-DARKHEATHER/5XL",
                "color": "DARKHEATHER",
                "size": "5XL"
            },
            {
                "sku": "PRT_G5000-DARKHEATHER/4XL",
                "color": "DARKHEATHER",
                "size": "4XL"
            }
        ],
        "brand": null,
        "printer": "US1",
        "name": "Unisex T-shirt | G5000",
        "sku": "Unisex-Gildan-UnisexT-Shirt",
        "id": "ec777ddb-05e6-4376-bed3-eac908c85706"
    },
]
export default printik
